import "../About/About.css"
import { motion } from 'framer-motion';
export default function About(){
    return <motion.div  
    className="MainDivAbout"
    initial={{
        x:-105,
        opacity:0
    }}
    whileInView={{ 
        x:0,
        opacity:1
    }}
    transition={{
        duration:1,
    }}>
    <p className="About">About Me</p>
    <p className="Discription" id="Discrip">
        I am a student of Lovely Professional University who likes coding lengthy scripts to creatively solve strange problems. When I get free time, 
        I enjoy spending that time designing and creating website and developing Applications<br/><br/>
        I am really passionate about tech and learning new programming languages and I love to develop new things. 
        I keep myself updated with the latest technologies in the market, and try to gain experience in them. 
        I primarily use javascript, but picking up a new framework or language isn't a problem. 
        I have good programming skills and I'm comfortable in Full Stack Web Development using MERN stack and Application Development using Fluter.<br/><br/>
    </p>
    </motion.div>
}